
import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator'
@Component
export default class InputSear extends Vue {
    @Prop()
    placeholder
    @Prop()
    value
    @Prop()
    datalist
    @Prop()
    showName
    @Prop()
    disabled
    val = '123'
    sear_box: any = {
        open: false,
        show_list: []
    }
    get datalist_new() {
        let dlist = this.datalist
        let datalist_new: any = []
        if (dlist.length) {
            if (dlist[0].value == null || dlist[0].value == undefined) {
                this.datalist.map((item) => {
                    datalist_new.push({
                        value: item,
                        name: item
                    })
                })
            } else {
                datalist_new = this.datalist
            }
        }

        return datalist_new
    }
    OpenQuickSel() {
        this.sear_box.open = true
        this.sear_box.show_list = this.datalist_new
    }
    CloseQuickSel() {
        setTimeout(() => {
            this.sear_box.open = false
        }, 150)
    }
    QuickSel(val) {
        this.$emit('input', val)
        this.$emit('ChangeAppID', val)
    }
    UserInput(event) {
        let str = event.target.value
        let reg = new RegExp(`${str}`)
        this.sear_box.show_list = this.datalist_new.filter((v) => reg.test(v.value))
        this.$emit('input', str)
        this.$emit('ChangeAppID', str)
    }
}
